import { ReactNode, useState } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Collapse from '@mui/material/Collapse';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface ExpandMoreProps extends IconButtonProps {
    open: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { open, ...other } = props;
    return (
        <IconButton disableRipple {...other}>
            <ExpandMoreIcon />
        </IconButton>
    );
})(({ theme, open }) => ({
    transform: !open ? 'rotate(0deg)' : 'rotate(180deg)',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

interface CollapsibleProps {
    header: React.ReactNode | string;
}

// Same React 18 children-typing fix applied to LanguageContextProvider /
// DataContextProvider in earlier sub-steps: `React.FC` no longer implies
// `children`. Declare the prop explicitly so JSX nesting (`<Collapsible
// header="...">{...}</Collapsible>`) keeps compiling.
const Collapsible: React.FC<CollapsibleProps & { children?: ReactNode }> = ({ header, children }) => {
    const [open, setOpen] = useState(true);
    return (
        <Box padding=".5rem">
            <Paper variant="outlined" style={{ width: '100%', padding: '.25rem 1rem' }}>
                <Box display="flex" alignItems="center">
                    <ButtonBase disableRipple style={{ flex: 1, justifyContent: 'flex-start' }} onClick={() => setOpen(!open)}>
                        {typeof header === 'string' ? <Typography>{header}</Typography> : header}
                    </ButtonBase>
                    <ExpandMore open={open} onClick={() => setOpen(!open)} />
                </Box>
                <Collapse in={open}>
                    <Box padding=".5rem" paddingTop={0}>
                        {children}
                    </Box>
                </Collapse>
            </Paper>
        </Box>
    );
};

export default Collapsible;